/* src/app/features/habilitacao/habilitacao-alternativa/nova-habilitacao-alternativa/nova-habilitacao-alternativa.component.scss */
.row-disabled {
  pointer-events: none;
  cursor: not-allowed;
  background-color: #e9ecef;
  opacity: 0.8;
}
/*# sourceMappingURL=nova-habilitacao-alternativa.component.css.map */
